/**
 * EKIBOOST — Product Custom JS
 * Variant cards, formula toggle (subscribe / one-time),
 * AJAX ATC, qty stepper, sticky bar, gallery, accordion
 */
(function () {
  'use strict';

  var section = document.querySelector('[data-section-type="product-custom"]');
  if (!section) return;

  var productJson = section.querySelector('[data-product-json]');
  if (!productJson) return;

  var product;
  try { product = JSON.parse(productJson.textContent); }
  catch (e) { console.error('EKI: product JSON error', e); return; }

  /* ── DOM refs ── */
  var variantCards     = section.querySelectorAll('.eki-product__variant-card');
  var variantInput     = section.querySelector('[name="id"]');
  var sellingPlanInput = section.querySelector('[data-selling-plan-input]');
  var atcBtn           = section.querySelector('.eki-product__atc-btn');
  var atcText          = atcBtn ? atcBtn.querySelector('.eki-product__atc-text') : null;
  var qtyInput         = section.querySelector('.eki-product__qty-input');
  var qtyMinus         = section.querySelector('.eki-product__qty-btn--minus');
  var qtyPlus          = section.querySelector('.eki-product__qty-btn--plus');
  var mainImage        = section.querySelector('.eki-product__main-img');
  var thumbs           = section.querySelectorAll('.eki-product__thumb');
  var stockDot         = section.querySelector('.eki-product__stock-dot');
  var stockText        = section.querySelector('.eki-product__stock-text');

  /* Formula toggle refs */
  var formulaTabs      = section.querySelectorAll('.eki-formula__tab');
  var formulaPanels    = section.querySelectorAll('.eki-formula__panel');
  var subPriceEl       = section.querySelector('[data-sub-price]');
  var subCompareEl     = section.querySelector('[data-sub-compare]');
  var subSavingEl      = section.querySelector('[data-sub-saving]');
  var onetimePriceEl   = section.querySelector('[data-onetime-price]');
  var onetimeCompareEl = section.querySelector('[data-onetime-compare]');
  var formulaWrap      = section.querySelector('.eki-formula');
  var subPctDiscount   = formulaWrap ? parseInt(formulaWrap.dataset.subPct) || 15 : 15;

  /* Sticky refs */
  var stickyBar   = document.querySelector('.eki-product__sticky');
  var stickyPrice = stickyBar ? stickyBar.querySelector('.eki-product__sticky-price') : null;
  var stickyAtc   = stickyBar ? stickyBar.querySelector('.eki-product__sticky-atc') : null;

  /* State */
  var currentVariant = null;
  var currentFreq    = 'subscribe';
  var userClicked    = false;

  /* ATC price ref */
  var atcPriceEl = section.querySelector('[data-atc-price]');

  /* ── Helpers ── */
  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
  }

  function getDisplayPrice(v) {
    if (!v) return '';
    return currentFreq === 'subscribe' ? fmt(getSubPrice(v)) : fmt(v.price);
  }

  function updateAtcPrice() {
    if (atcPriceEl && currentVariant) atcPriceEl.textContent = getDisplayPrice(currentVariant);
  }

  function getBasePrice(v) {
    return (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;
  }

  function getSubPrice(v) {
    return Math.round(getBasePrice(v) * (1 - subPctDiscount / 100));
  }

  function getSellingPlan(v) {
    if (!product.selling_plan_groups || !product.selling_plan_groups.length) return null;
    for (var g = 0; g < product.selling_plan_groups.length; g++) {
      var plans = product.selling_plan_groups[g].selling_plans;
      if (plans && plans.length) return plans[0];
    }
    return null;
  }

  /* ── Update formula prices ── */
  function refreshFormulaPrices(v) {
    if (!v) return;
    var base    = getBasePrice(v);
    var subPx   = getSubPrice(v);
    var saving  = base - subPx;

    if (subPriceEl)    subPriceEl.textContent    = fmt(subPx);
    if (subCompareEl) {
      subCompareEl.textContent = fmt(base);
      subCompareEl.style.display = saving > 0 ? '' : 'none';
    }
    if (subSavingEl)   subSavingEl.textContent   = saving > 0 ? '-' + fmt(saving) : '';

    if (onetimePriceEl) onetimePriceEl.textContent = fmt(v.price);
    if (onetimeCompareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        onetimeCompareEl.textContent = fmt(v.compare_at_price);
        onetimeCompareEl.style.display = '';
      } else {
        onetimeCompareEl.style.display = 'none';
      }
    }

    /* Sticky bar price */
    if (stickyPrice) {
      stickyPrice.textContent = currentFreq === 'subscribe' ? fmt(subPx) : fmt(v.price);
    }
  }

  /* ── Variant selection ── */
  function selectVariant(vid) {
    var v = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === vid) { v = product.variants[i]; break; }
    }
    if (!v) return;
    currentVariant = v;

    if (variantInput) variantInput.value = v.id;

    variantCards.forEach(function (c) {
      c.classList.toggle('eki-product__variant-card--active', parseInt(c.dataset.variantId) === v.id);
    });

    refreshFormulaPrices(v);
    updateSellingPlan(v);

    /* Availability */
    if (atcBtn) {
      atcBtn.disabled = !v.available;
      if (atcText) {
        if (v.available) {
          atcText.innerHTML = 'Ajouter au panier \u2014 <span data-atc-price>' + getDisplayPrice(v) + '</span>';
          atcPriceEl = section.querySelector('[data-atc-price]');
        } else {
          atcText.textContent = 'Rupture de stock';
        }
      }
    }
    if (stickyAtc) stickyAtc.disabled = !v.available;
    updateStock(v);

    /* Image */
    if (v.featured_image && mainImage) { mainImage.src = v.featured_image.src; mainImage.srcset = ''; }

    /* URL — only on product pages, only on user click */
    if (userClicked && window.history && window.history.replaceState && window.location.pathname.indexOf('/products/') !== -1) {
      window.history.replaceState({}, '', window.location.pathname + '?variant=' + v.id);
    }
  }

  function updateSellingPlan(v) {
    if (!sellingPlanInput) return;
    if (currentFreq === 'subscribe') {
      var plan = getSellingPlan(v);
      sellingPlanInput.value = plan ? plan.id : '';
    } else {
      sellingPlanInput.value = '';
    }
  }

  /* ── Formula tab toggle ── */
  function selectFreq(freq) {
    currentFreq = freq;
    formulaTabs.forEach(function (t) { t.classList.toggle('eki-formula__tab--active', t.dataset.freq === freq); });
    formulaPanels.forEach(function (p) { p.classList.toggle('eki-formula__panel--active', p.dataset.panel === freq); });
    if (currentVariant) { refreshFormulaPrices(currentVariant); updateSellingPlan(currentVariant); updateAtcPrice(); }
  }

  formulaTabs.forEach(function (tab) {
    tab.addEventListener('click', function () { selectFreq(this.dataset.freq); });
  });

  /* ── Stock ── */
  function updateStock(v) {
    if (!stockDot || !stockText) return;
    if (!v.available) {
      stockDot.className = 'eki-product__stock-dot eki-product__stock-dot--out';
      stockText.textContent = 'Rupture de stock';
    } else if (v.inventory_quantity !== undefined && v.inventory_quantity <= 5 && v.inventory_quantity > 0) {
      stockDot.className = 'eki-product__stock-dot eki-product__stock-dot--low';
      stockText.textContent = 'Plus que ' + v.inventory_quantity + ' en stock';
    } else {
      stockDot.className = 'eki-product__stock-dot';
      stockText.textContent = 'En stock';
    }
  }

  /* ── Variant card clicks ── */
  variantCards.forEach(function (card) {
    card.addEventListener('click', function () {
      userClicked = true;
      var vid = parseInt(this.dataset.variantId);
      if (vid) selectVariant(vid);
    });
  });

  /* ── Qty stepper ── */
  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function () { var v = parseInt(qtyInput.value) || 1; if (v > 1) qtyInput.value = v - 1; });
    qtyPlus.addEventListener('click',  function () { var v = parseInt(qtyInput.value) || 1; qtyInput.value = v + 1; });
    qtyInput.addEventListener('change', function () { if (!parseInt(this.value) || parseInt(this.value) < 1) this.value = 1; });
  }

  /* ── AJAX Add to Cart ── */
  function addToCart(vid, qty) {
    if (atcBtn) { atcBtn.disabled = true; if (atcText) atcText.textContent = 'Ajout en cours\u2026'; }
    var savedPrice = currentVariant ? getDisplayPrice(currentVariant) : '';
    var body = { id: vid, quantity: qty };
    if (sellingPlanInput && sellingPlanInput.value) body.selling_plan = parseInt(sellingPlanInput.value);

    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('ATC fail'); return r.json(); })
      .then(function () {
        if (atcText) atcText.textContent = 'Ajout\u00e9 \u2713';
        setTimeout(function () {
          if (atcBtn) atcBtn.disabled = false;
          if (atcText) { atcText.innerHTML = 'Ajouter au panier \u2014 <span data-atc-price>' + savedPrice + '</span>'; atcPriceEl = section.querySelector('[data-atc-price]'); }
        }, 1500);
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.cart-link__bubble-num, .cart-link__count, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          document.querySelectorAll('.cart-link__bubble').forEach(function (b) { if (cart.item_count > 0) b.classList.add('cart-link__bubble--visible'); });
        });
      })
      .catch(function () {
        if (atcText) atcText.textContent = 'Erreur \u2014 r\u00e9essayer';
        setTimeout(function () {
          if (atcBtn) atcBtn.disabled = false;
          if (atcText) { atcText.innerHTML = 'Ajouter au panier \u2014 <span data-atc-price>' + savedPrice + '</span>'; atcPriceEl = section.querySelector('[data-atc-price]'); }
        }, 2000);
      });
  }

  if (atcBtn) atcBtn.addEventListener('click', function (e) { e.preventDefault(); var vid = parseInt(variantInput ? variantInput.value : 0); var qty = parseInt(qtyInput ? qtyInput.value : 1) || 1; if (vid) addToCart(vid, qty); });
  if (stickyAtc) stickyAtc.addEventListener('click', function (e) { e.preventDefault(); var vid = parseInt(variantInput ? variantInput.value : 0); if (vid) addToCart(vid, 1); });

  /* ── Sticky bar ── */
  if (stickyBar) {
    document.body.appendChild(stickyBar);
    var atcRow = section.querySelector('.eki-product__atc-row'), showSt = false;
    function checkSticky() { if (!atcRow) return; var r = atcRow.getBoundingClientRect(), s = r.bottom < 0; if (s !== showSt) { showSt = s; stickyBar.classList.toggle('eki-product__sticky--visible', s); } }
    window.addEventListener('scroll', checkSticky, { passive: true }); checkSticky();
  }

  /* ── Thumbnails ── */
  function activateThumb(thumb) {
    var src = thumb.dataset.fullSrc;
    if (src && mainImage) {
      mainImage.style.opacity = '0';
      setTimeout(function () {
        mainImage.src = src;
        mainImage.srcset = '';
        mainImage.style.opacity = '1';
      }, 250);
    }
    thumbs.forEach(function (x) { x.classList.remove('eki-product__thumb--active'); });
    thumb.classList.add('eki-product__thumb--active');
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      activateThumb(this);
      resetAutoSlide();
    });
  });

  /* ── Auto-slideshow (cycle through thumbnails) ── */
  var autoSlideInterval = null;
  var autoSlideDelay = 4000;

  function getActiveThumbIndex() {
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('eki-product__thumb--active')) return i;
    }
    return 0;
  }

  function nextSlide() {
    if (thumbs.length < 2) return;
    var idx = (getActiveThumbIndex() + 1) % thumbs.length;
    activateThumb(thumbs[idx]);
  }

  function startAutoSlide() {
    if (thumbs.length < 2) return;
    stopAutoSlide();
    autoSlideInterval = setInterval(nextSlide, autoSlideDelay);
  }

  function stopAutoSlide() {
    if (autoSlideInterval) { clearInterval(autoSlideInterval); autoSlideInterval = null; }
  }

  function resetAutoSlide() {
    stopAutoSlide();
    startAutoSlide();
  }

  /* Pause on hover, resume on leave */
  var mediaWrap = section.querySelector('.eki-product__media');
  if (mediaWrap) {
    mediaWrap.addEventListener('mouseenter', stopAutoSlide);
    mediaWrap.addEventListener('mouseleave', startAutoSlide);
  }

  startAutoSlide();

  /* ── Description toggle ── */
  var dToggle = section.querySelector('.eki-product__desc-toggle'), dBody = section.querySelector('.eki-product__desc-body');
  if (dToggle && dBody) dToggle.addEventListener('click', function () { var exp = dBody.classList.toggle('eki-product__desc-body--expanded'); this.textContent = exp ? 'Voir moins' : 'Voir plus'; });

  /* ── Accordions ── */
  section.querySelectorAll('.eki-accordion__header').forEach(function (h) {
    h.addEventListener('click', function () { var a = this.closest('.eki-accordion'), o = !a.classList.contains('eki-accordion--open'); a.classList.toggle('eki-accordion--open', o); this.setAttribute('aria-expanded', o); });
  });

  /* ── Init ── */
  (function () {
    var p = new URLSearchParams(window.location.search), uv = parseInt(p.get('variant'));
    if (uv) { selectVariant(uv); }
    else if (product.variants && product.variants.length) {
      var f = product.variants[0];
      for (var i = 0; i < product.variants.length; i++) { if (product.variants[i].available) { f = product.variants[i]; break; } }
      selectVariant(f.id);
    }
    selectFreq('subscribe');
  })();

})();
